import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import MarketPlaceFeedNavbar from './MarketPlaceFeedNavbar';
import axios from 'axios';
import FileViewer from './FileViewer';
import useMarketPlaceVerificationStatus from '../../hooks/useMarketPlaceVerificationStatus';
const BASE_URL = process.env.REACT_APP_BASE_URL;
const MarketPlaceSearchPage = () => {
    const { isVerified } = useMarketPlaceVerificationStatus();
    const navigate = useNavigate()
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const search = query.get("search");
    const type = query.get("type");
      const [pubExpanded, setPubExpanded] = useState(false);
    const [publications,setPublications] = useState([])
      useEffect(() => {
        if (!search || search.trim() === "") return;
        const fetchSearchResults = async () => {
          try {
            const response = await axios.get(
              `${BASE_URL}/marketplace/researcher/feed/search?q=${search}`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                  'x-api-key': process.env.REACT_APP_X_API_KEY,
                },
              }
            );
             console.log("The response is:",response.data)
            setPublications(response.data)
          } catch (error) {
            console.log("Error while search:", error)
          }
        }
        fetchSearchResults()
      }, [search])

  return (
    <>
     <MarketPlaceFeedNavbar  />

    <div className="p-0 md:p-6 w-full mx-auto">
      <h1 className='mb-4'> Search By  - {search}</h1>
     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {!publications ? (
          // Loader
          <div className="w-full flex justify-center items-center h-32">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500"></div>
          </div>
        ) : publications?.length === 0 ? (
          // No publications
          <div className="text-center text-gray-500 py-10">
            No publications found.
          </div>
        ) : (
          publications && publications?.map((post) => (
            <div
              key={post.id}
              onClick={() => {
  if (post?.research_type !== 'announcement') {
    navigate(`/marketplace/feed/post/${post.id}?research_type=${post.research_type}&type=${post.publication_type}`);
  }
}}
              className="mb-4 border border-gray-200 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-200"
            >
 <div className={`p-6 w-full ${post?.research_type === 'announcement' ? '' : 'cursor-pointer'}`}>
              {/* USER INFO */}
                {/* USER INFO */}
              <div className="flex items-center gap-3 justify-between mb-4">
                <div className="flex items-center gap-3"  onClick={(e)=>{
                     if(isVerified)
                     {
                        e.stopPropagation()
                       navigate(post?.university_data ? `/marketplace/university/${post?.university_data?.id}` : `/marketplace/feed/${post?.researcher}`)
                     }
                      
                    }}>
                  <img
                    src={post?.university_data ? post?.university_data.university_logo : post?.profile_data?.profile_picture}
                    alt="University"
                    className="w-12 h-12 rounded-xl object-cover border-2 border-white shadow-sm"
                   
                  />

                  <div className="flex flex-col">
                    <span className="font-semibold text-gray-900">
                      {post.university_data ? post?.university_data?.university_name :post?.profile_data?.name}
                    </span>
                                          <span className="text-xs text-gray-600 mt-0.5">
                        By <strong>{post.university_data ? post?.profile_data?.name : "Researcher"}</strong>
                      </span>
                  </div>
                </div>
              </div>

              {/* TAGS */}
              <div className="flex flex-wrap gap-2 mb-2">
                 {
                    post?.research_type === 'opportunity' ||  post?.research_type === 'lab_opportunity' ?   <div className="flex flex-wrap gap-2">
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {post?.domain}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 border border-blue-100">
      {post?.collaboration}
    </span>
    

    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {post?.maturity}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-green-50 text-green-600 border border-green-100">
      {post?.visibility}
    </span>
  </div> : post?.research_type === 'announcement' ? '' : <div className="flex flex-wrap gap-2">
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {post?.field_of_interest}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 border border-blue-100">
      {post?.area_of_interest}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {post?.topic_of_interest}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {post?.research_type === 'theoreticalidea' || 'labtheoreticalidea' && "Idea"}
      {post?.research_type === 'prototype' || 'labprototype' && "PoC"}
      {post?.research_type === 'labexperiment' || 'lab_labexperiment' && "Lab-ready"}
      {post?.research_type === 'industrialapplication' || 'labindustrialapplication'  && "Industry Challenge"}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-green-50 text-green-600 border border-green-100">
      {post?.visibility}
    </span>
  </div>
                }
              </div>

              {/* TITLE */}
              <div className="text-lg font-bold text-gray-900 mb-2">
                {post.name}
              </div>

              {/* MEDIA */}
              {
                post.publication_type ? <FileViewer publication_type={post.publication_type} file={post.file} name={post?.name}/> :
                <FileViewer publication_type={post.announcement_type} file={post.file} name={post?.name}/>
              }
              
              {
  post?.research_type === 'announcement' && 
  <div className="mt-3 sm:mt-4 text-base sm:text-lg text-gray-900 mb-2 break-words">
    
    <span
      dangerouslySetInnerHTML={{
        __html:
          pubExpanded || (post?.description?.length || 0) <= 220
            ? post?.description
            : post?.description.slice(0, 220) + "..."
      }}
    />

    {(post?.description?.length || 0) > 220 && (
      <span
        onClick={() => setPubExpanded(!pubExpanded)}
        className="text-blue-600 cursor-pointer ml-1 font-medium"
      >
        {pubExpanded ? " Read less" : " Read more"}
      </span>
    )}
  </div>
}
            </div>
            </div>
          )))
        }
      </div>
    </div>
    </>
  )
}

export default MarketPlaceSearchPage
